// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"DropdownBtn_dropdownMenu__fQvch"};